import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const excelDownloadSlice = createSlice({
  name: 'excelDownload',
  initialState: {
    addProduct: false,
    uploadPriceAndStock: false,
    isDownload: false,
  },
  reducers: {
    setAddProduct: (state, action: PayloadAction<boolean>) => {
      const addProduct = action.payload;
      state.addProduct = addProduct;
    },
    setUploadPriceAndStock: (state, action: PayloadAction<boolean>) => {
      const uploadPriceAndStock = action.payload;
      state.uploadPriceAndStock = uploadPriceAndStock;
    },
    setIsDownload: (state, action: PayloadAction<boolean>) => {
      const isDownload = action.payload;
      state.isDownload = isDownload;
    },
  },
});

export const { setAddProduct, setUploadPriceAndStock, setIsDownload } = excelDownloadSlice.actions;
export default excelDownloadSlice.reducer;
